import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Jump to a solution suite`('0.0.1')({
  gutterless: true,
  view: () => (
    <UI.Modules.Page.Reusable
      value={{
        path: 'insulation',
        name: 'Blog - Insulation Contractor/Homeowner',
      }}
    />
  ),
  edit: {},
});
